import React from 'react'
const Index = props => {
  return <h1>Hello World!</h1>
}
export default Index
